import { FullFormAction } from "../../../Engine/Core/Store/FullFormAction";
import { EmployerDocumentsState } from "../../EmployeeServiceState";
import { ImportEmployerDocumentsFilter } from "../../EmployeeServiceTypes";

import { EmployerDocumentsActionType } from "./EmployerDocumentsAction";
import { getSelectedFilterValueByType } from "./EmployerDocumentsStateUtils";

export function employerDocumentsReducer(
    state: EmployerDocumentsState | undefined,
    action: FullFormAction
): EmployerDocumentsState | undefined {
    let nextState = state;

    if (action.type === EmployerDocumentsActionType.BeginImport) {
        nextState = {
            ...nextState,
            showSideBar: true,
            loading: true,
            documents: [],
            activePage: 1,
            options: action.payload.options,
            filterType: action.payload.filterType,
            filterValue: action.payload.filterValue,
            resultDeferred: action.payload.deferredResult,
        };
    }
    if (action.type === EmployerDocumentsActionType.ChangeFilterType) {
        nextState = {
            ...(nextState as EmployerDocumentsState),
            loading: true,
            documents: [],
            activePage: 1,
            filterType: action.payload.filterType,
            filterValue: getSelectedFilterValueByType(
                action.payload.filterType,
                state?.options?.filter?.selectValues ?? ({} as ImportEmployerDocumentsFilter["selectValues"])
            ),
        };
    }
    if (action.type === EmployerDocumentsActionType.ChangeFilterValue) {
        nextState = {
            ...(nextState as EmployerDocumentsState),
            activePage: 1,
            filterValue: action.payload.filterValue,
        };
    }
    if (action.type === EmployerDocumentsActionType.BeginLoading) {
        nextState = {
            ...(nextState as EmployerDocumentsState),
            loading: true,
            documents: [],
        };
    }
    if (action.type === EmployerDocumentsActionType.CompleteLoading) {
        nextState = {
            ...(nextState as EmployerDocumentsState),
            loading: false,
            documents: action.payload.documents,
        };
    }
    if (action.type === EmployerDocumentsActionType.EndImport) {
        nextState = {
            ...nextState,
            showSideBar: false,
            loading: false,
            documents: [],
            activePage: 1,
            resultDeferred: undefined,
        };
    }
    if (action.type === EmployerDocumentsActionType.ChangePage) {
        nextState = {
            ...(nextState as EmployerDocumentsState),
            activePage: action.payload.pageNumber,
        };
    }

    return nextState;
}
